/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / kus`
};

const da_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / stk.`
};

const de_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / Stück`
};

const en_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / piece`
};

const es_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / unidad`
};

const fr_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / pièce`
};

const hu_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / darab`
};

const it_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / pezzo`
};

const nl_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / stuk`
};

const pl_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / szt.`
};

const pt_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / unidade`
};

const sv_unit_price = /** @type {(inputs: { price: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.price} / styck`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ price: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const unit_price = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.unit_price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("unit_price", locale)
	if (locale === "cs") return cs_unit_price(inputs)
	if (locale === "da") return da_unit_price(inputs)
	if (locale === "de") return de_unit_price(inputs)
	if (locale === "en") return en_unit_price(inputs)
	if (locale === "es") return es_unit_price(inputs)
	if (locale === "fr") return fr_unit_price(inputs)
	if (locale === "hu") return hu_unit_price(inputs)
	if (locale === "it") return it_unit_price(inputs)
	if (locale === "nl") return nl_unit_price(inputs)
	if (locale === "pl") return pl_unit_price(inputs)
	if (locale === "pt") return pt_unit_price(inputs)
	return sv_unit_price(inputs)
};